export default __webpack_public_path__ + "static/media/manage.5132c6fe.svg";